import { ButtonBase, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Tarjeta_Equipo = ({ imagen, nombre, descripcion, link }) => {
    const navigate = useNavigate();

    return (
        <Grid container size={{ xs: 12 }}>

            <Grid size={{ xs: 12, sm: 6, md: 5}} sx={{ mb: 2 }}>
                <img
                    src={imagen}
                    alt={`Foto de ${nombre}`}
                    width="800"
                    height="600"
                    style={{ width: '90%', height: '100%', objectFit: 'cover' }}
                />
            </Grid>
            <Grid size={{  xs: 12, sm: 6, md: 7 }} sx={{ mb: 1 }}>
                <Grid size={{ xs: 12 }} sx={{ mb: 4 }}>
                    <Typography
                        component="h3"
                        variant="h3"
                        sx={{  }}
                    >
                        {nombre}
                    </Typography>
                </Grid>

                {descripcion && (
                    <Grid size={{ xs: 12 }} sx={{ mb: 4 }}>
                        <Typography
                            component="p"
                            variant="body1"
                            sx={{}}
                        >
                            {descripcion}
                        </Typography>
                    </Grid>
                )}

                {link && (
                    <Grid size={{ xs: 12 }}>
                        <ButtonBase
                            onClick={() => navigate(link)}
                            sx={{
                                backgroundColor: '#223B59',
                                color: '#fff',
                                px: 3,
                                py: 1.5,
                                fontSize: 14,
                                fontWeight: 500,
                                borderRadius: 0,
                                transition: '0.3s',
                                '&:hover': { backgroundColor: '#1A2F47' },
                            }}
                        >
                            Conocer más de {nombre.split(' ')[0]}
                        </ButtonBase>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Equipo;